import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export interface PromotionalContent {
  id: string | number;
  title: string;
  description?: string | null;
  mediaUrl: string;
  mediaType: string;
  displayType: string;
  startDate: string;
  endDate: string;
  visibilityStatus: string;
  priorityOrder: number;
}

export interface AddPromotionalContent {
  title: string;
  description?: string;
  mediaUrl: string;
  mediaType: string;
  displayType: string;
  startDate: string;
  endDate: string;
  visibilityStatus?: string;
  priorityOrder?: number;
}

export interface GetPromotionalParams {
  page?: number;
  pageSize?: number;
  title?: string;
  mediaType?: string;
  displayType?: string;
  visibilityStatus?: string;
  orderBy?: string;
  orderDirection?: string;
  [key: string]: unknown;
}

export class PromotionalService {
  async getPromotionalContent(query?: GetPromotionalParams) {
    return apiService.get("/promotional", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getPromotionalContentDetails(id: string | number) {
    return apiService.get(`/promotional/${id}`);
  }

  async addPromotionalContent(data: AddPromotionalContent) {
    return apiService.post("/promotional", data);
  }

  async updatePromotionalContent(
    id: string | number,
    data: Partial<AddPromotionalContent>
  ) {
    return apiService.put(`/promotional/${id}`, data);
  }

  async deletePromotionalContent(id: string | number) {
    return apiService.delete(`/promotional/${id}`);
  }
}

export const promotionalService = new PromotionalService();
